import type { ArticuloInfo360VentaMensual } from './types';

export interface VentasPeriodoAprox {
  dias30: number;
  dias60: number;
  dias90: number;
}

/** Suma cantidades de los últimos N meses calendario (aprox. 30/60/90 días). */
export function calcVentasPeriodoAprox(
  ventasMensuales: ArticuloInfo360VentaMensual[],
): VentasPeriodoAprox {
  const sumUltimos = (meses: number) =>
    ventasMensuales.slice(-meses).reduce((acc, v) => acc + (v.cantidad ?? 0), 0);

  return {
    dias30: sumUltimos(1),
    dias60: sumUltimos(2),
    dias90: sumUltimos(3),
  };
}
